export default __webpack_public_path__ + "static/media/Impious Wristbands.09005775.jpg";